<template>
<div>

<div class="modal" id="productCombinations" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-info text-black">
        
        <h4> 
            <i style="color:#c71585" class="fas fa-cogs mr-2" aria-hidden="true"></i>  
            <strong>LISTA VARIANTI - {{product.productId}} - {{product.brand}} - {{product.sku}} - {{product.category}} - {{product.department}}   </strong> 
              <br>
              <small>doppio click selezione/deselezione colore</small> 
              
        </h4>
        
       
      </div>
      <div class="modal-body">
      
        <div class="table-wrapper-scroll-y my-custom-scrollbar">     
        <table class="table table-sm table-bordered">
        <thead >
            <tr>
            <th>
            ESCLUDI
            </th>
        
            <th>
            COLORE  
            </th>
            <th>
            MISURA
            </th>
            <th>
            BARCODE
            </th>        
            </tr>
            </thead>
        <tbody>
            <tr @dblclick="setColor(item)" v-for="(item,index) in rows" :key="index">
        
                <td>
                    <input  class="pointer"  type="checkbox"  v-bind:value="item.selected" v-model="item.selected" >                      
                </td>  
                <td >
                {{item.color}}
                </td>  
                <td >
                {{item.size}}
                </td>  
                <td >
                {{item.barcode}}
                </td>  

        
            </tr>
        </tbody>
  </table>
  </div>  


  
  <alert-box class="mt-3 mb-3" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>


  </div>
     
      <div class="modal-footer">
          <button type="button"  @click="$emit('close')" class="btn btn-outline-secondary ">CHIUDI</button>
          <button :disabled="rows.length==0" @click="saveData()"  type="button"  class="btn btn-primary ">
            <i class="fas fa-check mr-2" aria-hidden="true"></i>
            APPLICA
            <span v-if="spinner"  class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </button>  

      </div>
    </div>
  </div>
</div>    



</div> 

</template>

<script>


import api                from "@/api"
import alertBox           from '@/components/common/AlertBox.vue';




export default {
   props : ['product'],
   components: {alertBox},  
  

  data () {
    return {      
    
      rows            : [],  
      msg             : 
      {
        title : ''
      },
      alert           : false,
      spinner         : false

    }
  },
  computed: 
  {   
  },
   directives: 
    {

      focus: {
      
      inserted: function (el) 
      {
       
        //el.focus() 
      
      }
      
      }

    },
  mounted()
    {
        //document.getElementById("id_0").focus();
    },
  created()
  {
      

      this.rows = JSON.parse(this.product.data)
      
  },
  methods: 
  {
    setColor(row)
    {   
        
        this.rows.forEach(item=>{
            if(item.color == row.color)
            {  
                item.selected = item.selected ? 0 : 1
                
            }

        })
    },  
    async saveData()
    {
      
      this.spinner              = true
      let arr                   = []
    



      this.rows.forEach(item => {

          if(item.selected)
          {
            arr.push({'barcode' : item.barcode,'productId' : item.productId,'mpId' : item.mpId})
          }

      })

      let total     = this.rows.length - arr.length > 0 ? 1 : 0    
      let data      = {'productId' : this.rows[0].productId,'data' : arr,'mpId' : this.rows[0].mpId,'total':total}
      var sp        = {'sp' : 'spUpdateProductCombinationsToMarket'}
      var json      = Object.assign(data, sp)
      
      

      await api.post(json).then(res => {
          
          
          if(res.status==200)
            {
                this.$emit('update',this.rows,total)
                this.msg.title = "MODIFICA EFFETTUATA."
                this.msg.type  = 0
            }
           else if(res.status==500)
           {
               
                this.msg.title = 'ATTENZIONE'
                this.msg.body = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                            
                this.msg.title = 'ATTENZIONE'
                this.msg.body = res
                this.msg.type  = 1
                 
            } 

        

          }).catch(err => {
              
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type  = 1   

              
          }).finally(() => {
          this.spinner = false
        });





    }
  
  
  }
  
   
  
}

</script>

<style scoped>
.pointer
{
    cursor            : pointer;
}


h4 
{
    font-family: 'Roboto Condensed';
    font-size: 20px;
}
.bold
{
    font-weight  : bold;
}
    
label
{
    color  :  blue
}
p 
{
    font-family  : 'Roboto Condensed';
    font-size    : 25px;
}
span 
{
    font-family  : 'Roboto Condensed';
    font-size    : 15px;
}

.table thead tr:nth-child(1) th
{

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : burlywood;
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }
.my-custom-scrollbar {
    position   : relative;
    height     : 400px;
    overflow   : auto;
}


    .modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;

}
</style>